// extracted by mini-css-extract-plugin
export default {"container":"Gp-z","brandName":"Hp-z","productName":"Ip-z","productNamePdpEnhancements":"Jp-z","breakLongProductName":"Kp-z"};